import { User } from "types/User";
import apiClient from "./config";

export interface UserProfileUpdateData {
  id: string;
  email?: string | undefined;
  phone_number: string;
  dot: string;
  mc: string;
  first_name: string;
  last_name: string;
  company_legal_name: string;
  company_address: string;
  t_code: string;
  default_equipment_type?: string;
  permits: string[];
  general_preferences: string[];
}

export const updateUserProfile = async (data: UserProfileUpdateData | User) => {
  try {
    const response = await apiClient.put("ai-caller/user-profile", data);
    return response.data;
  } catch (error) {
    console.error("Error updating user profile:", error);
    throw error;
  }
};
